import { useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import useAuth from "../../../hooks/useAuth";
import BaseRating from "../../../components/ui/BaseRating";
import EngineerPrivateFeedbackModal from "../FeedbackModal";
import { useNavigate } from "react-router-dom";
import { UserType } from "../../../utils/enum";
import EditOverviewModal from "../components/EditOverviewModal";

const Overview = ({ workOrderDetail, hasUpdateAccess }) => {
  const { authRole } = useAuth();
  const navigate = useNavigate();
  const [isEditOverviewModalOpen, setIsEditOverviewModalOpen] = useState(false);
  const [engineerPrivateFeedbackModalOpen, setEngineerPrivateFeedbackModalOpen] = useState(false);

  return (
    <>
      <BaseCard className="pt-4 pb-6 xl:px-16 px-5 rounded-lg !mb-[0px]" elevation={1}>
        <div className="border-bottom mb-4 flex items-center pb-1">
          <h6 className="text-dark">Overview</h6>
          {(authRole === UserType.CLIENT || authRole === UserType.CUSTOMER) && hasUpdateAccess && (
            <i
              className="fa-light fa-pencil text-gray-900 ml-3 cursor-pointer"
              onClick={() => setIsEditOverviewModalOpen(true)}
            ></i>
          )}
        </div>
        <div className="grid xl:grid-cols-2 grid-cols-2 gap-x-10 gap-y-5">
          <div className="lg:col-span-1 col-span-2 flex lg:justify-start  justify-between  bg-light rounded-md py-1.5 px-3 sm:px-8">
            <p className="font-normal w-36 shrink-0">Company: </p>
            <p className="font-light min-w-0 break-words">{workOrderDetail?.createdBy?.company?.name}</p>
          </div>
          <div className="lg:col-span-1 col-span-2 flex lg:justify-start  justify-between bg-light rounded-md py-1.5 px-3 sm:px-8 cursor-pointer">
            <p className="font-normal w-36 shrink-0">Incident ID: </p>
            {workOrderDetail?.incidentId ? (
              <p className="font-light min-w-0 break-words">{workOrderDetail?.incidentId}</p>
            ) : (
              <div className="hidden xl:block"></div>
            )}
          </div>
          {(authRole === UserType.CLIENT || authRole === UserType.CUSTOMER) && (
            <div className="lg:col-span-1 col-span-2 flex lg:justify-start  justify-between bg-light rounded-md py-1.5 px-3 sm:px-8 ">
              <p className="font-normal w-36 shrink-0">Client: </p>
              <p className="font-light min-w-0 break-words">
                {workOrderDetail?.client?.clientName || "No client specified"}
              </p>
            </div>
          )}
          {/* Project is internal to the client — no other role sees it. */}
          {authRole === UserType.CLIENT && (
            <div className="lg:col-span-1 col-span-2 flex lg:justify-start  justify-between bg-light rounded-md py-1.5 px-3 sm:px-8 ">
              <p className="font-normal w-36 shrink-0">Project:</p>
              <p className="font-light min-w-0 break-words">
                {workOrderDetail?.project?.title || "No project specified"}
              </p>
            </div>
          )}

          <div className="lg:col-span-1 col-span-2 flex lg:justify-start  justify-between bg-light rounded-md py-1.5 px-3 sm:px-8 ">
            <p className="font-normal w-36 shrink-0">SLA:</p>
            <p className="font-light min-w-0 break-words">{workOrderDetail?.serviceLevelAgreeement || "N/A"}</p>
          </div>

          {authRole === UserType.CLIENT && workOrderDetail?.teamTasks?.length > 0 && (
            <div className="lg:col-span-1 col-span-2 flex lg:justify-start  justify-between bg-light rounded-md py-1.5 px-3 sm:px-8 ">
              <p className="font-normal w-36 shrink-0">Tasks:</p>
              {workOrderDetail?.teamTasks?.map((task, index) => (
                <p
                  key={task.id || index} // always add key when mapping
                  className="mr-1 text-primary cursor-pointer hover:underline"
                  onClick={() => navigate(`/taskBoard/${task.referenceId}`)}
                >
                  {task?.referenceId || "N/A"}
                  {index < workOrderDetail.teamTasks.length - 1 && ","}{" "}
                  {/* add comma except last */}
                </p>
              ))}
            </div>
          )}

          {workOrderDetail?.feedback?.feedbackReceived && (
            <div
              className="lg:col-span-1 col-span-2 flex lg:justify-start  justify-between bg-light rounded-md py-1.5 px-8  cursor-pointer"
              onClick={() => setEngineerPrivateFeedbackModalOpen(true)}
            >
              <p className="font-normal w-36 shrink-0">Feedback: </p>
              <div className="h-0" onClick={() => navigate(`feedback/${workOrderDetail?.id}`)}>
                <BaseRating rating={workOrderDetail?.feedback?.feedbackReceived?.rating} />
              </div>
            </div>
          )}
        </div>
      </BaseCard>
      {/* {engineerPrivateFeedbackModalOpen && (
        <EngineerPrivateFeedbackModal
          engineerPrivateFeedbackModalOpen={engineerPrivateFeedbackModalOpen}
          setEngineerPrivateFeedbackModalOpen={
            setEngineerPrivateFeedbackModalOpen
          }
          previewFeedback={workOrderDetail?.feedback}
        />
      )} */}
      {isEditOverviewModalOpen && (
        <EditOverviewModal
          open={isEditOverviewModalOpen}
          close={() => setIsEditOverviewModalOpen(false)}
          workOrderData={workOrderDetail}
        />
      )}
    </>
  );
};

export default Overview;
